import script from "./OnClickOutside.vue?vue&type=script&lang=js"
export * from "./OnClickOutside.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__